import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession(gameId, language, backUrl) {
    gaService.send('games', 'redpipe', gameId);
    return (await Vue.http.post('/api/redpipe/session/open', { gameId, language, backUrl })).data;
  },
  async openDemoSession(gameId, language, backUrl) {
    gaService.send('games-demo', 'redpipe', gameId);
    return (await Vue.http.post('/api/redpipe/session/opendemo', { gameId, language, backUrl })).data;
  },
  async closeSession() {
    return (await Vue.http.post('/api/redpipe/session/close')).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/redpipe.service.js